<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xXBvgs/tc-custom/9781641701723.jpg?1699737891096" alt="This image is the cover for the book Master American History in 1 Minute A Day"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Master American History in 1 Minute A Day
      </h1>
      <p class="bookDescription body article font2">
        <b>Become a US trivia whiz with this crash course through four centuries of change, rebellion, conflict, and triumph in the United States.</b><br/><br/><i>Where was America’s lost colony? What tipped the balance in the Civil War? Were there second thoughts about dropping the atomic bomb?</i><br/><br/> Acclaimed historian Dan Roberts—host of radio’s <i>A Moment in Time</i>—takes readers on a bite-sized romp through five-hundred years of American history. With just one minute a day, you can master all the essential facts of America's founding, Civil War, world conflicts, domestic transformations, and more.<br/><br/> Packed with full-color photographs, paintings, and lively mini essays, <i>Master American History in 1 Minute a Day</i> is the perfect armchair companion for history lovers and history learners alike.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dan Roberts
      </h2>
      
      <p class="authorDescription body article">If anyone can be accurately described as a Renaissance man, it would be Dan Roberts, executive producer and host of the award-winning radio series A Moment in Time. Created to excite and enlighten the public about the past and its relevance to the present and impact on the future, A Moment in Time is a captivating historical narrative that is currently broadcast worldwide. After receiving a BA in history from Presbyterian College in 1969, Roberts served as an officer in the US Army, including a tour in Vietnam where he was awarded the Bronze Star in 1971. Roberts began training as a Presbyterian minister and completed his professional education at Princeton Theological Seminary in 1974. In August, 1986, he served as guest chaplain of the United States Senate. In 1990, Roberts obtained a master's degree from the University of Richmond and, in 1997, a PhD in early modern British history and American colonial history from the University of Virginia. He is currently a professor of liberal arts and history at the University of Richmond and serves as chair of the department of liberal arts at the School of Professional and Continuing Studies. He has also been a guest contributor and columnist for Education Week, USA Today, Scripps-Howard papers, and Richmond Times-Dispatch. He is often heard as a history commentator on CNN, CNN Headline News, and Fox News. Dan is a popular jazz pianist and an avid reader. He travels each year to a part of the world for research in his continuous quest to bring history to life. He also spends a great deal of time on the road as a popular speaker for corporations, organizations, and national audiences. Roberts has three children: Heather Elizabeth Roberts Gill, Kathleen Taylor Roberts, and Daniel McDonald Roberts, III. He also has two lovely granddaughters: Ava McKenzie Hunt and Gerica Gill.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Familius LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10718c70